// disable eslint prefer-const

import { useEffect, useState } from 'react';
import * as S from './Avatar.styles';
import { AvatarFallback } from './Fallback/AvatarFallback';

export type AvatarProps = {
  icon?: JSX.Element | null;
  alt?: string;
  src?: string;
  size?: 'xs' | 'small' | 'medium' | 'large' | 'full';
  onclick?: () => void;
};

export const Avatar = ({ icon, src, alt, size, onclick }: AvatarProps) => {
  const [showFallback, setShowFallback] = useState(true);
  const onError = () => setShowFallback(true);

  useEffect(() => {
    setShowFallback(typeof src === 'undefined' || src === '');
  }, [src]);

  if (icon) {
    return <S.Wrapper size={size}>{icon}</S.Wrapper>;
  }

  // console.log('src', src);

  return (
    <S.Wrapper data-testid="avatar-wrapper" size={size}>
      {showFallback ? (
        <AvatarFallback aria-label={alt} onClick={onclick} />
      ) : (
        // <img
        //   src={`https${src?.split('https')?.[2]}`}
        //   // src={src}
        //   alt={alt}
        //   onError={onError}
        //   onClick={onclick}
        // />
        <img
          src={`https${src?.split('https')?.[2]}`}
          // src={src}
          alt={alt}
          onError={onError}
          onClick={onclick}
        />
      )}
    </S.Wrapper>
  );
};
